import React, {useContext} from 'react'
import {useI18N} from "../../../../../my-puratos/hoc/withI18N";
import {ProductContext} from "../../../../../pages/ProductStencil";

export const Specifications = () => {
    const translate = useI18N();
    const {SapDetails, activeProductIndex} = useContext(ProductContext);
    if(SapDetails?.length === 0){return <div className='accordion__specifications no-data'></div>}
    const {
        MaterialDescription,
        Packaging,
        MaterialNumber,
        Palletisation,
        EANUPCCode,
        TotalShelfLife
    } = SapDetails[activeProductIndex]
    const isNoData = !MaterialDescription && !Packaging && !MaterialNumber && !Palletisation && !EANUPCCode && !TotalShelfLife

    return (
        <div className={`${isNoData ? 'accordion__specifications no-data': 'accordion__specifications'}`}>
            {MaterialDescription && <p><b>{translate('Description')}: </b>{MaterialDescription}</p>}
            {MaterialNumber && <p><b>{translate('Product code')}: </b>{MaterialNumber}</p>}
            {Packaging && <p><b>{translate('Packaging')}: </b>{Packaging}</p>}
            {Palletisation && <p><b>{translate('Palletization')}: </b>{Palletisation}</p>}
            {TotalShelfLife && <p><b>{translate('Shelf life')}: </b>{TotalShelfLife}</p>}
            {EANUPCCode && <p><b>{translate('EAN Code')}: </b>{EANUPCCode}</p>}
        </div>
    )
}
